var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import { generateOptionsFromNumber } from '../../../helpers/formGeneratorHelper';
import './APDatePickerDropdown.css';
import { maxDate, minDate } from '../../../helpers/formValidations';
var APDatePickerDropdown = function (_React$Component) {
  _inherits(APDatePickerDropdown, _React$Component);
  function APDatePickerDropdown(props) {
    _classCallCheck(this, APDatePickerDropdown);
    var _this = _possibleConstructorReturn(this, (APDatePickerDropdown.__proto__ || Object.getPrototypeOf(APDatePickerDropdown)).call(this, props));
    _this.handleChange = function (date) {
      _this.props.input.onChange(date);
      if (_this.props.customChange) {
        _this.props.customChange(date);
      }
      _this.setState({
        date: new Date(date)
      });
    };
    _this.getClasses = function () {
      var customClasses = _this.props.customClasses;
      return getBEMClasses(['ap-datepicker-dropdown', 'ap-select', customClasses]);
    };
    _this.getDays = function () {
      var date = _this.state.date;
      var leadingZero = _this.props.leadingZero;
      var daysCount = _this.getDaysInMonth(date);
      return generateOptionsFromNumber(1, daysCount + 1, leadingZero ? 2 : 0);
    };
    _this.getMonths = function () {
      var months = [{
        value: 0,
        text: _this.context.t('January')
      }, {
        value: 1,
        text: _this.context.t('February')
      }, {
        value: 2,
        text: _this.context.t('March')
      }, {
        value: 3,
        text: _this.context.t('April')
      }, {
        value: 4,
        text: _this.context.t('May')
      }, {
        value: 5,
        text: _this.context.t('June')
      }, {
        value: 6,
        text: _this.context.t('July')
      }, {
        value: 7,
        text: _this.context.t('August')
      }, {
        value: 8,
        text: _this.context.t('September')
      }, {
        value: 9,
        text: _this.context.t('October')
      }, {
        value: 10,
        text: _this.context.t('November')
      }, {
        value: 11,
        text: _this.context.t('December')
      }];
      return months.map(function (month) {
        return React.createElement('option', {
          key: month.value,
          value: month.value
        }, month.text);
      });
    };
    _this.getYears = function () {
      var _this$props = _this.props,
        minYear = _this$props.minYear,
        maxYear = _this$props.maxYear,
        leadingZero = _this$props.leadingZero;
      var today = new Date();
      minYear = minYear || 1900;
      maxYear = maxYear || today.getFullYear();
      return generateOptionsFromNumber(minYear, maxYear + 1, leadingZero ? 2 : 0).reverse();
    };
    _this.onDayChange = function (e) {
      var value = e.target.value;
      var date = _this.state.date;
      date.setDate(+value);
      _this.handleChange(date);
    };
    _this.onMonthChange = function (e) {
      var value = e.target.value;
      var date = _this.state.date;
      var currentDays = date.getDate();

      // If user's selected month has less days than the actual month we set the day to the latest in that given month
      // else month will change to next because of the days difference
      date.setDate(1);
      date.setMonth(value);
      var monthDays = _this.getDaysInMonth(date);
      if (currentDays > monthDays) date.setDate(monthDays);
      _this.handleChange(date);
    };
    _this.onYearChange = function (e) {
      var value = e.target.value;
      var date = _this.state.date;
      date.setFullYear(value);
      _this.handleChange(date);
    };
    _this.getCurrentValue = function () {
      var date = _this.state.date;
      return {
        day: date.getDate(),
        month: date.getMonth(),
        year: date.getFullYear()
      };
    };
    _this.state = {
      date: new Date()
    };
    return _this;
  }
  _createClass(APDatePickerDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.props.input.value;
      if (value) {
        var date = new Date(value);
        this.setState({
          date: date
        });
      }
    }
  }, {
    key: 'getDaysInMonth',
    value: function getDaysInMonth(date) {
      return new Date(date.getYear(), date.getMonth() + 1, 0).getDate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        label = _props.label,
        meta = _props.meta,
        info = _props.info,
        customClass = _props.customClass,
        leadingZero = _props.leadingZero,
        minYear = _props.minYear,
        maxYear = _props.maxYear,
        minDate = _props.minDate,
        maxDate = _props.maxDate,
        otherProps = _objectWithoutProperties(_props, ['label', 'meta', 'info', 'customClass', 'leadingZero', 'minYear', 'maxYear', 'minDate', 'maxDate']);
      var baseClasses = this.getClasses();
      var value = this.getCurrentValue();
      return React.createElement('div', {
        className: 'form-group ' + baseClasses('select-wrapper')
      }, React.createElement('label', {
        className: 'ap--label ' + baseClasses('label')
      }, label), React.createElement('div', {
        className: baseClasses('input')
      }, React.createElement('select', Object.assign({
        value: value.day,
        className: baseClasses('select'),
        onChange: this.onDayChange
      }, otherProps), this.getDays()), React.createElement('select', Object.assign({
        value: value.month,
        className: baseClasses('select'),
        onChange: this.onMonthChange
      }, otherProps), this.getMonths()), React.createElement('select', Object.assign({
        value: value.year,
        className: baseClasses('select'),
        onChange: this.onYearChange
      }, otherProps), this.getYears())), React.createElement('div', {
        className: 'form-text-muted ' + baseClasses('info')
      }, info), meta.dirty && meta.error && React.createElement('div', {
        className: baseClasses('error', 'dpk-error')
      }, meta.error));
    }
  }]);
  return APDatePickerDropdown;
}(React.Component);
APDatePickerDropdown.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  customClass: PropTypes.string,
  info: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  disabled: PropTypes.bool,
  leadingZero: PropTypes.bool,
  minYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
};
APDatePickerDropdown.contextTypes = {
  t: PropTypes.func
};
APDatePickerDropdown.defaultProps = {
  label: 'Date',
  customClass: 'custom-datepicker',
  info: '',
  disabled: false,
  leadingZero: true
};
var minDateProp = void 0;
var maxDateProp = void 0;
var maxDateValidation = function maxDateValidation(value) {
  return maxDateProp && maxDate(value, new Date(maxDateProp));
};
var minDateValidation = function minDateValidation(value) {
  return minDateProp && minDate(value, new Date(minDateProp));
};
var maxMinValidations = [maxDateValidation, minDateValidation];
export default function APDatePicker(props) {
  minDateProp = props.minDate;
  maxDateProp = props.maxDate;
  var validate = props.validate,
    otherProps = _objectWithoutProperties(props, ['validate']);
  var validators = validate ? [].concat(_toConsumableArray(validate), maxMinValidations) : maxMinValidations;
  return React.createElement(Field, Object.assign({}, otherProps, {
    component: APDatePickerDropdown,
    validate: validators,
    name: props.name
  }));
}
export { APDatePickerDropdown };